
import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator';
import DateTimePicker from '@/components/DateTimePicker.vue';
import Util from '@/utils/util';
import imageConvert from '@/utils/image';

@Component({
  components: { DateTimePicker },
})
export default class BannerForm extends Vue {
  @Prop({}) private name!: string;

  @Prop({}) private startTime!: string;

  @Prop({}) private endTime!: string;

  @Prop({ default: true }) private isEnabled!: boolean;

  @Prop({}) private wideImageUrl!: string;

  @Prop({}) private narrowImageUrl!: string;

  @Prop({}) private url!: string;

  @Prop({ default: false }) private loading!: boolean;

  private valid: boolean = false;

  private widePic: any = '';

  private narrowPic: any = '';

  private form = {
    name: this.name,
    startTime: this.startTime,
    endTime: this.endTime,
    isEnabled: this.isEnabled,
    wideImageUrl: this.wideImageUrl,
    narrowImageUrl: this.narrowImageUrl,
    widePic: this.wideImageUrl,
    narrowPic: this.narrowImageUrl,
    url: this.url,
  };

  private rules = {
    name: [this.requiredRule('名稱'), this.maxLengthRule('名稱', 200)],
    startTime: [
      this.requiredRule('上架時間'),
      this.lessThenRule(
        '上架時間',
        '上架時間',
        (vm: BannerForm) => vm.form.endTime,
      ),
    ],
    endTime: [
      this.requiredRule('下架時間'),
      this.greaterThenRule(
        '下架時間',
        '下架時間',
        (vm: BannerForm) => vm.form.startTime,
      ),
    ],
    widePic: [this.validatePic((vm: BannerForm) => vm.widePic)],
    narrowPic: [this.validatePic((vm: BannerForm) => vm.narrowPic)],
  };

  private get inputs() {
    return {
      name: this.name,
      startTime: this.startTime,
      endTime: this.endTime,
      isEnabled: this.isEnabled,
      wideImageUrl: this.wideImageUrl,
      narrowImageUrl: this.narrowImageUrl,
      url: this.url,
    };
  }

  private get datePeriod() {
    return {
      startOn: this.form.startTime,
      endOn: this.form.endTime,
    };
  }

  @Watch('inputs', { immediate: true })
  private inputsWatcher(val: any) {
    this.form = {
      ...val,
    };
    this.widePic = this.wideImageUrl;
    this.narrowPic = this.narrowImageUrl;
  }

  @Watch('datePeriod')
  private datePeriodWatcher(val: any) {
    const inputs: any[] = (this.$refs.form as any).inputs.filter(
      (i: any) => i.label === '上架時間' || i.label === '下架時間',
    );
    inputs.forEach((input) => {
      input.validate(true);
    });
  }

  private requiredRule(column: string) {
    return (v: any) => !Util.isNullOrEmpty(v) || `${column} 為必填`;
  }

  private maxLengthRule(column: string, length: number) {
    return (v: any) => v?.length <= length || `${column} 最多 ${length} 字`;
  }

  private lessThenRule(
    column: string,
    column2: string,
    func: (vm: BannerForm) => any,
  ) {
    return (v: any) => {
      const c = func(this);
      return !v || !c || v <= c || `${column}要小於${column2}`;
    };
  }

  private greaterThenRule(
    column: string,
    column2: string,
    func: (vm: BannerForm) => any,
  ) {
    return (v: any) => {
      const c = func(this);
      return !v || !c || v >= c || `${column}要大於${column2}`;
    };
  }

  private validatePic(func: (vm: BannerForm) => any) {
    return (v: any) => {
      const p = func(this);
      return !!v || !!p || '請上傳圖片';
    };
  }

  private handleClearImage(imageStyle: string) {
    if (imageStyle === 'wide') {
      this.form.wideImageUrl = '';
      this.widePic = '';
    } else {
      this.form.narrowImageUrl = '';
      this.narrowPic = '';
    }
  }

  private changeImage(event: any, imageStyle: string) {
    const imagePic = URL.createObjectURL(event);
    if (imageStyle === 'wide') {
      this.form.wideImageUrl = event;
      this.widePic = imagePic;
    } else {
      this.form.narrowImageUrl = event;
      this.narrowPic = imagePic;
    }
  }

  private async cancel() {
    await this.$router.back();
  }

  @Emit()
  private async submit() {
    const form = this.$refs.form as any as { validate: () => boolean };
    if (form.validate()) {
      return {
        ...this.form,
        wideImageUrl: await imageConvert(this.form.wideImageUrl as any),
        narrowImageUrl: await imageConvert(this.form.narrowImageUrl as any),
      };
    }
    return null;
  }
}
